import { useState, useEffect } from "react";
import { apiFetch } from "@/lib/jwt-auth-client";

export function useIsAdmin() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isStaff, setIsStaff] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiFetch("/auth/admin-check/", { cache: "no-store" })
      .then((res) => res.json())
      .then((data) => {
        setIsAdmin(data.isAdmin === true);
        setIsStaff(data.isStaff === true || data.isAdmin === true);
      })
      .catch(() => {
        setIsAdmin(false);
        setIsStaff(false);
      })
      .finally(() => setLoading(false));
  }, []);

  return { isAdmin, isStaff, loading };
}
